// extracted by mini-css-extract-plugin
module.exports = {"import":"dttot_import__2m5Yu","importBtn":"dttot_importBtn__2w0BZ","error":"dttot_error__3VVLu"};